import { combineReducers } from 'redux';
import { apiInitialState, apiRequest, apiFailure } from 'ml-fetch';

const invitationReducer = (state = {}, action) => {
	function updateApiState(state = apiInitialState(), action) {
		switch (action.type) {
			case 'INVITATION_REQUEST':
				return apiRequest(state);

			case 'INVITATION_SUCCESS':
				return {
					...state,
					data: action.response.result,
					isFetching: false,
					hasError: false,
					didInvalidate: false,
					lastUpdated: action.receivedAt
				}

			case 'INVITATION_FAILURE':
				return apiFailure(state);

			default:
				return state;
		}
	}

	switch (action.type) {
		case 'INVITATION_REQUEST':
		case 'INVITATION_SUCCESS':
		case 'INVITATION_FAILURE':
			return {
				...state,
				[action.invitationId]: updateApiState(state[action.invitationId], action)
			}

		default:
			return state;
	}
}

const invitationsReducer = combineReducers({
	invitations: invitationReducer
})

export default invitationsReducer;



/** WEBPACK FOOTER **
 ** ./src/reducer/invitationReducer.js
 **/